import { useEffect, useRef, useState } from "react";
import ReelLoader from "./LoadingReel";
import { POST_ID_BUFFER_LENGTH_REF } from "../config";

const SQUARE_SIZE = 10;
const GAP = 10;
const TOTAL = SQUARE_SIZE + GAP;

const ReelContent = ({ scenes, count }) => (
  <>
    <div className="movie-reel-row">
      {Array.from({ length: count }).map((_, i) => (
        <span key={`top-${i}`} className="movie-reel-square" />
      ))}
    </div>

    <div className="movie-reel-scenes">
      {scenes.map((scene, i) => (
        <div key={i}>
          <img
            key={i}
            className="movie-reel-poster"
            src={scene.poster}
            alt=""
          />
        </div>
      ))}
    </div>

    <div className="movie-reel-row">
      {Array.from({ length: count }).map((_, i) => (
        <span key={`bot-${i}`} className="movie-reel-square" />
      ))}
    </div>
  </>
);

const MovieReel = ({ scenes = [] }) => {
  const firstStripRef = useRef(null);

  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isPaused, setIsPaused] = useState(true);
  const [scrollDistance, setScrollDistance] = useState(0);

  const postId = window.location.pathname.split("/").pop();

  // square count
  useEffect(() => {
    const updateCount = () => {
      const width = window.innerWidth;
      setCount(Math.ceil(width / TOTAL) + (POST_ID_BUFFER_LENGTH_REF[postId] || 0));
    };

    updateCount();
    window.addEventListener("resize", updateCount);
    return () => window.removeEventListener("resize", updateCount);
  }, []);

  // preload posters
  useEffect(() => {
    if (!scenes.length) return;

    const promises = scenes.map(scene => {
      return new Promise(resolve => {
        const img = new Image();
        img.src = scene.poster;
        img.onload = resolve;
        img.onerror = resolve;
      });
    });

    Promise.all(promises).then(() => {
      setIsLoading(false);
    });
  }, [scenes]);

  // measure one strip width 
  useEffect(() => {
    if (!firstStripRef.current) return;

    const width = Math.round(
      firstStripRef.current.scrollWidth
    );

    setScrollDistance(width - 1);
  }, [isLoading, count]);

  const duration = scrollDistance / 100;

  return (
    <>
      {isLoading && <ReelLoader />}

      <div className={`movie-reel-content ${isLoading ? "" : "show"}`}>
        <section className="movie-reel-strip">
          <div className="movie-reel-viewport">
            <div
              className={`movie-reel-track ${isPaused ? "paused" : ""}`}
              style={{
                "--scroll-distance": `${scrollDistance}px`,
                animationDuration: `${duration}s`
              }}
            // onClick={() => setIsPaused(prev => !prev)}
            >
              {/* STRIP 1 */}
              <div ref={firstStripRef} className="movie-reel-inner">
                <ReelContent scenes={scenes} count={count} />
              </div>

              {/* STRIP 2 */}
              <div className="movie-reel-inner">
                <ReelContent scenes={scenes} count={count} />
              </div>

              {/* STRIP 3 */}
              <div className="movie-reel-inner">
                <ReelContent scenes={scenes} count={count} />
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default MovieReel;